import React, { useContext, useState } from 'react';

import { ApiRoutes, FetchContext, HttpMethods } from '../../contexts';


export const HomeContext = React.createContext(null);

const { Provider } = HomeContext;

export const HomeProvider = (props) => {

    const { utente, fetchOk, fetchAuthorized } = useContext(FetchContext);


    const [comuniWithoutOffice, setComuniWithoutOffice] = useState(false);
    const [ufficiUncovalidated, setUfficiUncovalidated] = useState(false);

    const [isLoadingComuni, setIsLoadingComuni] = useState(false);
    const getComuniAsync = async (pageIndex = 0, pageSize = 1, term, provinciaId, valid = true, orphans = true) => {
        try {
            setIsLoadingComuni(true);
            const r = await fetchAuthorized(ApiRoutes.Comune.GetComuni({ pageIndex, pageSize, term, provinciaId, valid, orphans }), {
                method: HttpMethods.GET
            });
            const list = await r.json();
            list.result = list.result.map(e => { return { ...e, dataIstituzione: new Date(e.dataIstituzione), dataCessazione: e.dataCessazione ? new Date(e.dataCessazione) : null, } });

            setComuniWithoutOffice(list.result.length > 0);
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingComuni(false);
        }
    }

    const [isLoadingUffici, setIsLoadingUffici] = useState(false);
    const getUfficiAsync = async (pageIndex = 0, pageSize = 10, convalidato = false) => {
        try {
            setIsLoadingUffici(true);
            const r = await fetchAuthorized(ApiRoutes.Ufficio.GetUffici(), {
                method: HttpMethods.POST,
                body: JSON.stringify({ pageIndex, pageSize, convalidato, }),
            });
            const list = await r.json();
            setUfficiUncovalidated(list.result);
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingUffici(false);
        }
    }

    return (
        <Provider value={{
            comuniWithoutOffice,
            ufficiUncovalidated,
            isLoadingComuni,
            getComuniAsync,
            isLoadingUffici,
            getUfficiAsync,
        }}>
            {props.children}
        </Provider>
    );
}